import { ReactNode } from "react";
import { SelectOption } from "@/components/Select";
import { Destination } from "@/interfaces/catalogs.interface";

export enum DeliveryMethods {
  ACCOUNT_DEPOSIT = "D2B",
  CASH_PICKUP = "CPU",
}
export type DeliveryMethodCode = "D2B" | "CPU";

export type PaymentMethodCode = "Sendola ACH" | "PayPal" | "Venmo" | "Zelle";

export interface PaymentMethod {
  default: boolean;
  paymentOrigin: string;
  paymentMethodFee: number;
  totalCost: number;
}

export interface PaymentMethodConfig {
  icon: ReactNode;
  order: number;
}

export interface PaymentDestination {
  id: string;
  destination: string;
  payerSpecificCode: string;
  rail: string;
  isPayerBranchRequired: boolean;
}

export interface DeliveryMethod {
  deliveryMethodId: number;
  deliveryMethodCode: DeliveryMethodCode;
  fee: number;
  fx: number;
  amountToReceive: number;
  paymentMethods: PaymentMethod[];
  paymentDestinations: PaymentDestination[];
}

export interface Quote {
  originCurrency: string;
  destinationCurrency: string;
  amount: number;
  rail: string;
  deliveryMethods: DeliveryMethod[];
  isReceiveAmount?: boolean;
}

export type QuotesPerChannel = Record<QuoteChannel, Quote | undefined>;

export interface Quotation {
  isReceiveAmount?: boolean;
  currentQuotation?: Quote;
  countryDestination?: string;
  currentDeliveryMethod?: DeliveryMethod;
  currentPaymentMethod?: PaymentMethods;
  currentPaymentDestination?: Destination;
  currentChannel?: QuoteChannel;
  quotesPerChannel?: QuotesPerChannel;
}

export type DestinationByCountry = {
  country: string;
  method: DeliveryMethodCode;
  destinations: SelectOption[];
};

export type PaymentMethods = "Zelle" | "PayPal" | "Venmo" | "ACH";

export enum QuoteChannel {
  lessFee = "Cheaper Fee",
  bestFx = "Best FX",
}
export type QuoteChannels = "Cheaper Fee" | "Best FX";

export interface QuoteSelectedValue {
  amount?: number;
  currency?: string;
  country?: string;
  deliveryMethod?: DeliveryMethodCode;
  sendTo?: string;
  currentQuote?: Quote["deliveryMethods"][number];
  paymentMethod?: PaymentMethods;
  channel?: QuoteChannel;
  isReceiveAmount?: boolean;
}

export interface QuoterFormValues {
  amount: string;
  amountToReceive: string;
  currency?: string;
  country?: string;
  channel: QuoteChannels;
  deliveryMethod: DeliveryMethodCode;
  cpuSelected?: string;
  d2bSelected?: string;
}
